import styles from './menu-item-spacer.module.css';

export function MenuItemSpacer() {
  return <li aria-hidden="true" className={styles.menuItemSpacer} />;
}
